import { render } from "./TopClientsBarChart.vue?vue&type=template&id=12616704&scoped=true"
import script from "./TopClientsBarChart.vue?vue&type=script&lang=js"
export * from "./TopClientsBarChart.vue?vue&type=script&lang=js"

import "./TopClientsBarChart.vue?vue&type=style&index=0&id=12616704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12616704"]])

export default __exports__